import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { immerable } from 'immer';

import dayjs from '../../../core/configs/dayjs';

export type SelectedMember = {
	id: number;
	name: string;
	isGroup: boolean;
	avatar: AvatarEntity | null;
};

interface IMemberItem {
	id: number;
	creationDate: dayjs.Dayjs | null;
	updateDate: dayjs.Dayjs | null;
	login: string;
	firstName: string;
	lastName: string;
	mail: string;
	avatar: AvatarEntity | null;
	name: string;
	description: string;
	identifyName: string;
	isGroup: boolean;
}

type UserMember = Omit<IMemberItem, 'name' | 'description' | 'identifyName'>;

type GroupMember = {
	id: number;
	name: string;
	description: string;
	creationDate: dayjs.Dayjs | null;
	updateDate: dayjs.Dayjs | null;
	isGroup: boolean;
};

const entityDefaults: IMemberItem = {
	id: -1,
	creationDate: null,
	updateDate: null,
	login: '',
	firstName: '',
	lastName: '',
	mail: '',
	avatar: null,
	name: '',
	description: '',
	isGroup: false,
	identifyName: '',
};

export class MemberItemEntity implements IMemberItem {
	private [immerable] = true;

	public id = entityDefaults.id;
	public avatar = entityDefaults.avatar;
	public creationDate = entityDefaults.creationDate;
	public updateDate = entityDefaults.updateDate;
	public login = entityDefaults.login;
	public firstName = entityDefaults.firstName;
	public lastName = entityDefaults.lastName;
	public mail = entityDefaults.mail;
	public name = entityDefaults.name;
	public description = entityDefaults.description;
	public isGroup = entityDefaults.isGroup;
	public identifyName = entityDefaults.identifyName;

	public static buildMember(params: Partial<IMemberItem>): MemberItemEntity {
		if (params.isGroup) {
			return this.buildGroupMember(params);
		}
		return this.buildUserMember(params);
	}
	private static buildUserMember(
		params: Partial<UserMember>
	): MemberItemEntity {
		return new MemberItemEntity({
			id: params.id,
			login: params.login,
			firstName: params.firstName,
			lastName: params.lastName,
			mail: params.mail,
			creationDate: params.creationDate,
			updateDate: params.updateDate,
			isGroup: false,
			identifyName: `${params.firstName} ${params.lastName}`,
		});
	}
	private static buildGroupMember(
		params: Partial<GroupMember>
	): MemberItemEntity {
		return new MemberItemEntity({
			id: params.id,
			name: params.name,
			description: params.description,
			creationDate: params.creationDate,
			updateDate: params.updateDate,
			isGroup: true,
			identifyName: params.name,
		});
	}
	private constructor(params: Partial<IMemberItem>) {
		this.id = params.id ?? entityDefaults.id;
		this.login = params.login ?? entityDefaults.login;
		this.firstName = params.firstName ?? entityDefaults.firstName;
		this.lastName = params.lastName ?? entityDefaults.lastName;
		this.mail = params.mail ?? entityDefaults.mail;
		this.name = params.name ?? entityDefaults.name;
		this.description = params.description ?? entityDefaults.description;
		this.creationDate = params.creationDate ?? entityDefaults.creationDate;
		this.updateDate = params.updateDate ?? entityDefaults.updateDate;
		this.isGroup = params.isGroup ?? entityDefaults.isGroup;
		this.identifyName = params.identifyName ?? entityDefaults.identifyName;

		this.avatar = params.login
			? AvatarEntity.build(params.login)
			: AvatarEntity.build(`${params.firstName} ${params.lastName}`);
	}
}
